import { Box, ContentBlock } from 'braid-design-system';
import { Fragment, type ReactNode } from 'react';

import Header from 'src/components/Header/Header';

interface PaymentContainerProps {
  children: ReactNode;
}

export const PaymentContainer = ({ children }: PaymentContainerProps) => (
  <Fragment>
    <Header title="Sell your business" />
    <ContentBlock>
      <Box marginY="medium">{children}</Box>
    </ContentBlock>
  </Fragment>
);
